module.exports = __webpack_public_path__ + "media/icons/no_check-96974f00.png";